var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorBase',{scopedSlots:_vm._u([{key:"errorMessage",fn:function(){return [_vm._v("404 - "+_vm._s(_vm.message))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }